<template>
  <v-form>
    <v-container>
      <span v-if="editPumpId == -1" class="headline">{{$t('create_pump')}}</span>
      <span v-if="editPumpId != -1" class="headline">{{$t('edit_pump')}}</span>

      <v-row>
        <v-col cols="12" lg="2" md="3" sm="4">
           <v-select v-model="pump.type" :items="pumpTypes" :label="$t('pump.pump_type')"></v-select>

        </v-col>

   <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="pump.stage" :label="$t('pump.stage')"></v-text-field>
        </v-col>
     
        <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="pump.motor_power_50hz" suffix="HP" :label="$t('motor.power') + ' 50Hz'" required></v-text-field>
        </v-col>
        <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="pump.motor_power_60hz" suffix="HP" :label="$t('motor.power') + ' 60Hz'" required></v-text-field>
        </v-col>

        

        <!-- <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="pump.material" label="Material"></v-text-field>
        </v-col> -->

        <!-- <v-col cols="12" md="5" lg="4" sm="5">
          <v-select required v-model="pump.motorid" :items="motors" label="Motor"></v-select>
        </v-col> -->

     
      </v-row>
      <!-- <v-row> -->
        <!-- <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field
            v-model="pump.max_shaft_power"
            suffix="kW"
            label="Maximum Shaft Power"
            required
          ></v-text-field>
        </v-col> -->

        <!-- <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="pump.p2" suffix="kW" label="P2" required></v-text-field>
        </v-col>
      </v-row> -->

      <!-- <v-row>
        <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field
            v-model="pump.b"
            suffix="mm"
            label="B"
          ></v-text-field>
        </v-col>
        <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="pump.c" suffix="mm" label="C" required></v-text-field>
        </v-col>
      </v-row> -->

      <v-row>
        <!-- <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="pump.a" suffix="mm" label="A" required></v-text-field>
        </v-col> -->
<v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="pump.c" suffix="mm" :label="$t('pump.length')" required></v-text-field>
        </v-col>
        <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="pump.weight" suffix="kg" :label="$t('pump.weight')" required></v-text-field>
        </v-col>

         
   
        <!-- <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="pump.fi_e" suffix="kg" label="Fi E" required></v-text-field>
        </v-col>
         -->

      </v-row>
      <v-row>
      <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="pump.price" suffix="$" :label="$t('pump.price')" required></v-text-field>
        </v-col>

          
      </v-row>
      <div class="my-2">
        <v-btn v-if="editPumpId == -1" color="primary" @click="savePump">{{$t('save')}}</v-btn>
        <v-btn v-if="editPumpId != -1" color="primary" @click="savePump">{{$t('update')}}</v-btn>
      </div>
    </v-container>
  </v-form>
</template>

<script>
export default {
  name: "PompaOlustur",

  data: () => ({
    token: "",
    query: "",
    pumpTypes: [],
    pump: {
      idpump: -1,
      motorid: null,
      price: "",
      motor_power_50hz: "",
      motor_power_60hz: "",
      type: "",
      stage: "",
      b: "",
      c: "",
      a: "",
      material: "Stainless Steel",
      max_shaft_power: 100,
      p2: 70,
      fi_d: "6",
      fi_e: 40,
      weight: "",
    },
    motors: []
  }),

  props: {
    editPumpId: {
      type: String,
      default: "-1"
    }
  },

  mounted: function() {
    if(localStorage.token){
      this.token = localStorage.token
      this.$http.defaults.headers.common['Authorization'] = `Bearer ${this.token}` 
    }
    this.fetchMotors();
    this.fetchPumpTypes()
  },
  methods: {
    fetchPumpTypes: function() {
      this.pumpTypes = [];
      this.$http.get(this.$API_URL + "pump_types").then(result => {
        result.data.forEach(pumpType => {
          this.pumpTypes.push({
            text: `${pumpType.type} ${pumpType.fi_e}" ${pumpType.fi_r}mm`,
            value: (pumpType.idpump_type).toString()
          });
        });
      });
    },
    fetchPump: function(editPumpId) {
      this.$http
        .get(this.$API_URL + "pump?idpump=" + editPumpId)
        .then(result => {
          this.pump = result.data;
        });
    },

    savePump: function() {
      var targetUrl = this.editPumpId == -1 ? "save_pump" : "update_pump";

      this.$http({
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        url: this.$API_URL + targetUrl,
        data: this.pump,
        query: {
          update: true
        }
      })
        .then(function(response) {
          console.log(response.data)
          if (response.data == "1")
             window.history.go(-1)
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    fetchMotors: function() {
      this.motors = [];
      this.$http.get(this.$API_URL + "motors").then(result => {
        result.data.forEach(motor => {
          this.motors.push({
            text: motor.type +" ("+motor.power+" HP, "+motor.nominal_current+" A, )",
            value: motor.idmotor
          });
        });

        if (this.editPumpId != -1) {
          this.fetchPump(this.editPumpId);
        }
      });
    }
  }
};
</script>
